/*
 * Language switcher. The href is the real page (/uz/price, /price, …).
 * On click we also write shamcrm_locale so geo middleware does not send
 * the visitor back to a country default. Cookie name must stay in sync
 * with config/site/geo.php.
 */

const COOKIE = "shamcrm_locale";
const MAX_AGE = 60 * 60 * 24 * 365;

function rememberLocale(locale) {
    if (!locale) return;

    const secure = window.location.protocol === "https:" ? ";Secure" : "";

    document.cookie =
        `${COOKIE}=${encodeURIComponent(locale)};Path=/;Max-Age=${MAX_AGE};SameSite=Lax${secure}`;
}

export function initLocaleSwitch() {
    document.querySelectorAll("[data-site-locale]").forEach((link) => {
        const save = () => rememberLocale(link.dataset.siteLocale);

        // Left click uses click. Middle click (open in new tab) uses auxclick.
        link.addEventListener("click", save);
        link.addEventListener("auxclick", save);
    });
}
